import { AfterViewInit, Component, ComponentFactoryResolver, Input, OnDestroy, ViewChild } from '@angular/core';
/** Import Data Model Types */
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, forEach } from 'lodash';
import { StoresService } from '../../../core/services/stores';
import { RepoSettingsService } from '../../../data/repositories/repo-settings.service';
import { SecondaryNavThemeService } from '../navigation_secondary/v2/secondary-nav-theme.service';
import { NotificationItem } from './notification-item';
import { NotificationComponent, NotificationLevel } from './notification.component';
import { NotificationDirective } from './notification.directive';
import { NotificationBannerService } from './notification.service';
import { NotificationVerfiyAccountComponent } from './notification.verfiy-account.component';

/** Import Data Model Types */

/**
 * @title Notifications Wrapper Component with Launch Darkly toggles
 */
@UntilDestroy()
@Component({
    selector: 'notifications',
    templateUrl: './notifications.component.html',
    standalone: false,
})
export class NotificationsComponent implements AfterViewInit, OnDestroy {
    // @ts-ignore TS2564
    @Input() columnLayout: string;

    notifications: NotificationItem<NotificationComponent>[] = [];
    activeNotifications: NotificationItem<NotificationComponent>[] = [];
    currentNotificationIndex = 0;
    dismissible = false;
    currentNotificationLevel: NotificationLevel | undefined;

    // @ts-ignore TS2564
    @ViewChild(NotificationDirective) notificationItem: NotificationDirective;

    constructor(
        public settings: RepoSettingsService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private notificationService: NotificationBannerService,
        private readonly storesService: StoresService,
        private themeService: SecondaryNavThemeService
    ) {
        this.settings = settings;
    }

    ngAfterViewInit() {
        this.storesService.isUserDataLoaded$.pipe(untilDestroyed(this)).subscribe(() => this.initNotification());
    }

    initNotification() {
        this.getNotifications();
        const notificationWithTimers = filter(
            this.notifications,
            (a: NotificationVerfiyAccountComponent) => a.data.isActiveIn
        ) as NotificationItem<NotificationVerfiyAccountComponent>[];
        forEach(notificationWithTimers, (notificationWithTimer) => {
            setTimeout(() => {
                notificationWithTimer.data.isActive = true;
                this.getActiveNotifications();
                this.loadNotification();
            }, notificationWithTimer.data.isActiveIn * 1000);
        });

        this.notificationService.updateNotifications.pipe(untilDestroyed(this)).subscribe((e) => {
            this.getNotifications();
        });
    }

    async getNotifications() {
        this.notifications = await this.notificationService.getNotifications();
        this.getActiveNotifications();
        if (this.notifications.length > 0) {
            this.currentNotificationIndex = 0;
            this.loadNotification();
        }
        this.themeService.setDefaultTheme();
    }

    ngOnDestroy() {}

    // @ts-ignore TS7006
    onDismiss(index) {
        this.notifications.splice(index, 1);
        if (this.notifications.length > 0) {
            this.currentNotificationIndex = 0;
            this.loadNotification();
        } else {
            this.settings.NotificationsDismissed = true;
        }
    }

    // @ts-ignore TS7006
    onSetNotification(currentNotificationIndex) {
        this.currentNotificationIndex = currentNotificationIndex;
        this.loadNotification();
    }

    onNextNotification() {
        this.currentNotificationIndex++;
        if (this.currentNotificationIndex >= this.activeNotifications.length) this.currentNotificationIndex = 0;
        this.loadNotification();
    }

    onPrevNotification() {
        this.currentNotificationIndex--;
        if (this.currentNotificationIndex < 0) this.currentNotificationIndex = this.activeNotifications.length - 1;
        this.loadNotification();
    }

    loadNotification() {
        if (this.notificationItem && this.notificationItem.viewContainerRef) {
            const n_item = this.activeNotifications[this.currentNotificationIndex];

            if (n_item && n_item.data) {
                this.dismissible = n_item.data.dismissible;

                const viewContainerRef = this.notificationItem.viewContainerRef;
                viewContainerRef.clear();

                const componentFactory = this.componentFactoryResolver.resolveComponentFactory(n_item.component);
                const componentRef = viewContainerRef.createComponent(componentFactory);
                (<NotificationComponent>componentRef.instance).data = n_item.data;
                this.currentNotificationLevel = n_item.data.level;
            }
        }
    }

    getActiveNotifications() {
        this.activeNotifications = this.notifications.filter((notification) => notification.data.isActive === true);
    }
}
